import React, { Component } from 'react';
import {Modal} from 'react-bootstrap';
import OrganizationSelectionPage from './OrganizationSelectionPage'

class OrganizationSelectionModal extends Component {
    constructor(props) {
        super(props)
  
        this.state = {show:this.props.show}
    }
    
    componentDidMount(){
      if(this.props.onRef!==undefined){
        this.props.onRef(this)
      }
    }

    showModal(show){
        this.setState({show:show})
    }

    render(){
        let {show} = this.state
        
        return (
          <Modal show={show} enforceFocus={false} onHide={()=>{this.setState({show:false})}} dialogClassName={"midwidth-dialog"}>
            <Modal.Header closeButton>
              <Modal.Title>{'เลือกบริษัท/สาขา '}</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{padding:'0'}}>
                 <OrganizationSelectionPage/>
            </Modal.Body>
          </Modal> 
        )
      }
}

OrganizationSelectionModal.defaultProps = {
    show : false
}
export default OrganizationSelectionModal;


// WEBPACK FOOTER //
// ./src/view/org/OrganizationSelectionModal.js